import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { PieChartConfig } from '../GCharts/PieChartConfig';
import { saveAs as importedSaveAs } from "file-saver";


import { ReporteViaje } from '../Models/ReporteViaje';
import { Usuario } from '../Models/Usuario';
import { Vehiculo } from '../Models/Vehiculo';
import { ViajeReciboConforme } from '../Models/ViajeReciboConforme';
import { VisitaReciboConforme } from '../Models/VisitaReciboConforme'

import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { UsuarioService } from '../services/usuario.service';
import { VehiculoService } from '../services/vehiculo.service';
import { ViajeService } from '../services/viaje.service';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';



;
@Component({
  selector: 'app-reporte-viaje-recibo-conforme',
  templateUrl: './reporte-viaje-recibo-conforme.component.html',
  styleUrls: ['./reporte-viaje-recibo-conforme.component.css']
})
export class ReporteViajeReciboConformeComponent implements OnInit {

  public reporteViaje: ReporteViaje = new ReporteViaje();
  public reporteViajes: ReporteViaje[];


  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];


  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public viajeRecibo: ViajeReciboConforme = new ViajeReciboConforme();
  public viajeRecibos: ViajeReciboConforme[];

  public visitaRecibo: VisitaReciboConforme = new VisitaReciboConforme();
  public visitaRecibos: VisitaReciboConforme[];

  //trae las sumas y los contadores para el footer del reporte
  public visitaRecibosSumas: VisitaReciboConforme[];

  public nombreUsuario: string;
  public nombrePunto: string;
  public idVehiculo: string;
  public fechaInicio: Date;
  public fechaFin: Date;

  public mostrarRecibo: boolean = false;

  public path: any;

  constructor(private reporteService: ReporteViajeService, private globalServices: GlobalsService,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService, private viajeService: ViajeService, private domSanitizer: DomSanitizer,
    private generarReporteService: GeneradorTemplateService, private utilesService: UtilesService) {

  }
  ngOnInit() {
    this.CargarVehiculos();
    this.CargarUsuarios();
  }
  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }



  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }



  CargarReporteViajes() {
    try {
      if (this.usuario.idUsuario === undefined || this.usuario.idUsuario === "") {
        this.usuario.idUsuario = null;
      }
      if (this.nombrePunto === undefined || this.nombrePunto === "") {
        this.nombrePunto = null;
      }
      if (this.vehiculo.idvehiculo === undefined || this.vehiculo.idvehiculo === "") {
        this.vehiculo.idvehiculo = null;
      }
      if (this.fechaInicio === null) {
        this.fechaInicio = undefined;
      }

      if (this.fechaInicio === undefined || this.fechaInicio.toString() == "") {
        this.fechaInicio = null;
      }

      if (this.fechaFin === null) {
        this.fechaFin = undefined;
      }

      if (this.fechaFin === undefined || this.fechaFin.toString() == "") {
        this.fechaFin = null;
      }



      this.reporteService.ObtenerReporteViaje(this.globalServices.ObtenerCompania(), this.usuario.idUsuario, this.nombrePunto
        , this.vehiculo.idvehiculo, this.fechaInicio,
        this.fechaFin).subscribe(
          data => {
            this.reporteViajes = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("cargar reporte viajes: " + error);
    }

  }

  RegistroSeleccionado(item) {

    this.reporteViaje = JSON.parse(JSON.stringify(item));

    this.CargarViajeReciboConforme(this.reporteViaje.idViaje);

    this.CargarVisitasReciboConforme(this.reporteViaje.idViaje)
  }

  CargarViajeReciboConforme(idViaje: string) {
    try {


      this.viajeService.ObtenerViajeReciboConforme(this.globalServices.ObtenerCompania(), idViaje).subscribe(
        data => {
          this.viajeRecibo = data;
          this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.viajeRecibo.firma);

          this.mostrarRecibo = true;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarViajeReciboConforme: " + error);
    }

  }

  CargarVisitasReciboConforme(idViaje: string) {
    try {


      this.viajeService.ObtenerVisitaReciboConforme(this.globalServices.ObtenerCompania(), idViaje).subscribe(
        data => {
          this.visitaRecibos = data;

       
          this.CargarVisitasReciboConformeSumas(idViaje);
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitasReciboConforme: " + error);
    }

  }



  Regresar() {
    this.mostrarRecibo = false;
  }


  GenerarReporte() {

    //nombre que va a tener el archivo
    var nombre = "ViajeReciboConforme " + this.reporteViaje.idViaje
    var archivo = this.utilesService.getURLReportes() + nombre + ".pdf";

    this.generarReporteService.ReporteViajeReciboConforme(this.globalServices.ObtenerCompania(), this.reporteViaje.idViaje, nombre).subscribe(
      res => {

       
        if(res.tipoResultado==="ERROR"){
          swal("Error, "+ res.mensaje, "", "error");
            return
        }

        var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
        var fileName = "Reporte Carga Camión.pdf";

        importedSaveAs(resultado, fileName);

      }
    )
  }


  /**
   * Obtiene el footer del reporte viaje recibo conforme
   * @param idViaje 
   */
  CargarVisitasReciboConformeSumas(idViaje: string) {
    try {


      this.viajeService.ObtenerVisitaReciboConformeSumas(this.globalServices.ObtenerCompania(), idViaje).subscribe(
        data => {
          this.visitaRecibosSumas = data;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitasReciboConformeSumas: " + error);
    }

  }



  /**
   * Convierte la tabla asignada en un exel
   * @param tableID 
   * @param filename 
   */
  exportTableToExcel(tableID, filename = '') {
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }

}
